<template>
  <div class="basket-page">
    <el-row  :type="type_position()" class="row-bg" justify="center" :span="24">
      <el-col :xs="20" :sm="15" :md="15" :lg="17" :xl="17" :offset="1" class="m-b-20">
        <el-table :data="basketItemsGetter" border stripe>
          <el-table-column label="Зураг" width="150">
            <template slot-scope="scope">
              <img :src="'https://dmafilemanagement.s3.ap-southeast-1.amazonaws.com/images/' + scope.row.img_url" class="product-image"/>
            </template>
          </el-table-column>
          <el-table-column prop="product_name" label="Нэр" />
          <el-table-column label="Үнэ">
            <template slot-scope="scope">{{ scope.row.item_price | formatCurrency }}</template>
          </el-table-column>
          <el-table-column label="Тоо ширхэг" size="small" width="200">
            <template slot-scope="scope">
              <el-input-number
                size="mini"
                v-model="scope.row.item_count"
                :min="1"
                :max="1000"
              />
            </template>
          </el-table-column>
          <el-table-column label="Нийт үнэ">
            <template slot-scope="scope">
              {{ scope.row.item_price * scope.row.item_count | formatCurrency }}
            </template>
          </el-table-column>
          <el-table-column label="Үйлдэл" width="100">
            <template>
              <el-button type="danger" icon="el-icon-delete" @click="removeCardItem(item)">
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col><br>
      <el-col :xs="20" :sm="7" :md="6" :lg="5" :xl="5" :offset="1">
      <!-- Sidebar Summary Section -->
      <el-aside width="300px" class="basket-summary">
        <el-card>
          <h3 class="m-b-30">Нийт сагс</h3>
          <div class="summary-row">
            <span>Нийт тоо ширхэг</span>
            <span>{{ totalCountCalc() }}</span>
          </div>
          <div class="summary-row total">
            <span>Нийт үнэ</span>
            <span>{{ totalAmountCalc() | formatCurrency }}</span>
          </div>
          <el-button :style="'background-color:' + bgColor()" class="m-t-20 w-100 white_text thin_text signup_button" @click="goToCheckout()">
            Захиалах
          </el-button>
        </el-card>
      </el-aside>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'basketItemsGetter',
      'basketItemsGetterCount'
    ])
  },
  methods: {
    removeCardItem (item) {
      this.$store.dispatch('remove_basket', item)
    },
    goToCheckout () {
      this.$router.push({
        path: '/checkout'
      })
    },
    totalAmountCalc () {
      let sum = 0
      let total = 0
      this.basketItemsGetter.forEach(element => {
        sum = element.item_price * element.item_count
        total = sum + total
      })
      return total
    },
    totalCountCalc () {
      let sum = 0
      this.basketItemsGetter.forEach(element => {
        sum = element.item_count + sum
      })
      return sum
    },
    type_position () {
      if (this.windowWidth > 900) {
        return 'flex'
      } else {
        return 'none'
      }
    },
    bgColor () {
      if (window.location.hostname === 'iteever.mn') {
        return '#5E1EE5'
      } else if (window.location.hostname === 'eruulhun.com') {
        return '#64a29f'
      } else if (window.location.hostname === 'localhost') {
        return '#64a29f'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.basket-page {
  padding: 20px;
  background-color: #f5f5f5;
}

.product-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
}

.basket-summary {
  padding: 20px;
  background-color: #fff;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.total {
  font-weight: bold;
}

.checkout-button {
  width: 100%;
  margin-top: 20px;
}
</style>
